export const FEATURE_FLAGS = {
  LEGAL_LINKS: true,         // Phase 1 - enable after testing
  DELETE_ACCOUNT: true,      // Phase 2 - critical, test thoroughly
  AGE_VERIFICATION: true,    // Phase 3 - blocks sign-ups if broken
  PAID_SUBSCRIPTIONS: true, // IAP enabled - $3.99/week with 1 week free trial
};

